import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';

export const getStrippedPath = (path: string) => (path.startsWith('/') ? `${path.substring(1)}` : path);
export const normalizePath = (path: string) => (path.endsWith('/') ? path : `${path}/`);

/**
 * convert urls with query prams to be Alice friendly
 * /hello?q=world ---> /hello/?q=world
 */
export const addSlash = (url: string) => url.replace(/([^/])(\?)/, `$1/?`);
export default getStrippedPath;

/**
 * This is polyfill for URLSearchParams.
 * URLSearchParams does not work on Edge version lower than 17
 * @param path
 * @param query
 */
export const getUrlParameter = (path: string, query: string): string => {
    // eslint-disable-next-line no-useless-escape
    const name = query.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(path);
    return results && results[1] ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
};

export const isValidAbsoluteUrl = (url: string): boolean => {
    try {
        // eslint-disable-next-line no-new
        new URL(url);
    } catch (e) {
        return false;
    }
    return true;
};

export const shouldRenderHreflangs = (path: string): boolean =>
    SEO_CONSTANTS.pageNoHreflangsParams.every(key => getUrlParameter(path, key) === '');

export const hasPageNoIndexParams = (path: string): boolean =>
    SEO_CONSTANTS.pageNoindexParams.some(key => getUrlParameter(path, key) !== '');

export const resolveRobots = (indexFollow: boolean, pageUrlQuery: string): string =>
    indexFollow && !hasPageNoIndexParams(pageUrlQuery) ? SEO_CONSTANTS.indexable : SEO_CONSTANTS.noIndexable;
